interface BrandLogoProps {
  className?: string;
  alt?: string;
  src?: string;
}

export function BrandLogo({
  className = 'h-8 w-auto',
  alt = 'ENTEK.AI',
  src = '/entek_logo.png',
}: BrandLogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      decoding="async"
    />
  );
}
